module.exports = __webpack_public_path__ + "img/icon2.9fe445f0.png";